import type { IntegrationAdapter } from "./adapters.ts";
import {
  createIntegrationRegistry,
  executeIntegrationOperation,
  runIntegrationHealthCheck,
  type IntegrationContext,
} from "./service.ts";

export const integrationEndpoints = {
  healthCheck: (
    connectionId: string,
    context: IntegrationContext,
    adapters: IntegrationAdapter[],
    deps: { idFactory: (prefix: string) => string }
  ) => runIntegrationHealthCheck(connectionId, context, createIntegrationRegistry(adapters), deps),
  execute: <TPayload, TResult>(
    input: {
      connectionId: string;
      operation: string;
      payload: TPayload;
      idempotencyKey?: string;
    },
    context: IntegrationContext,
    adapters: IntegrationAdapter[],
    deps: Parameters<typeof executeIntegrationOperation<TPayload, TResult>>[3]
  ) => executeIntegrationOperation<TPayload, TResult>(input, context, createIntegrationRegistry(adapters), deps),
};
